export default __webpack_public_path__ + "static/media/info-logo.0a9b04f9.png";